import { decoratedCa } from 'shared/mf-infrastructure/utils/analytics';

interface ITrackRulerOpenParams {
  objectType: string | null;
  blockType: string;
  profile: string | null;
}

export function trackRulerOpen({ objectType, blockType, profile }: ITrackRulerOpenParams) {
  decoratedCa('eventSite', {
    action: 'click_sopr',
    category: 'Infrastructure',
    label: 'ruler',
    name: 'oldevent',
    page: {
      extra: {
        profile,
        object_type: objectType,
        block_type: blockType,
      },
    },
    useLastProducts: true,
  });
}
